<template>
  <div class="row mt-5">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              class="nav-item nav-link"
              active-class="active"
              aria-controls="nav-profile"
              aria-selected="false"
              to="">
            Sitzungsprotokolle
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>

</style>